import { defineStore } from 'pinia';
import { documentDetailApiService } from 'src/services';
import type { dynamicObj } from 'src/pages/assets';
import { i18n } from 'src/boot/i18n';

export const useDatePatternDropdownStore = defineStore(
  'date_pattern_dropdown',
  {
    state: () => ({
      date_pattern_list: [] as any,
      date_pattern_loading: false,
      date_pattern_loaded: false,
    }),
    actions: {
      async getDatePatternOptions() {
        try {
          this.date_pattern_loading = true;
          this.date_pattern_list = [];
          const response = await documentDetailApiService.getDatePatternList();

          if (!response) {
            throw response;
          }

          for (const [key, option] of Object.entries(response)) {
            const item = option as dynamicObj;
            const description = !item.description ? '' : item.description;
            this.date_pattern_list.push(
              Object.assign(
                {},
                {
                  value: item.value,
                  label: item.label,
                  description: description.replaceAll('\\n', '<br />'),
                },
              ),
            );
          }

          this.date_pattern_loaded = true;
        } catch (err) {
          logError(err);
        } finally {
          this.date_pattern_loading = false;
        }
      },
    },
  },
);
